export enum OrderChannel {
  Shopify = 'Shopify',
  Stripe = 'Stripe',
  Manual = 'Manual',
}
